<div class="tw-min-h-screen tw-bg-slate-50 tw-py-12 tw-px-4">
  <div class="tw-max-w-4xl tw-mx-auto">

    <div class="tw-mb-8">
      <h1 class="tw-text-2xl tw-font-bold tw-text-slate-900">Publicar Vacante</h1>
      <p class="tw-mt-1 tw-text-slate-500 tw-text-sm">Completa los datos para crear una nueva vacante</p>
    </div>

    <form [formGroup]="formVac" (ngSubmit)="validarVacante()">

      <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6 tw-mb-6" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
        <h2 class="tw-text-base tw-font-semibold tw-text-slate-800 tw-mb-5">Información General</h2>
        <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4">

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Nombre de la Vacante*</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="Desarrollador de Software" formControlName="nombre">
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Número de Vacantes*</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="1" formControlName="numVacantes">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formVac.controls.numVacantes.errors && formVac.controls.numVacantes.dirty">
              <div *ngIf="formVac.controls.numVacantes.errors.required">El número de vacantes es requerido.</div>
              <div *ngIf="formVac.controls.numVacantes.errors.pattern">El número de vacantes solo permite números.</div>
              <div *ngIf="formVac.controls.numVacantes.errors.maxlength">El número de vacantes solo permite como máximo 3 dígitos.</div>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Descripción de la Vacante*</label>
            <textarea class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" rows="4" placeholder="Desarrollador en Back-End..." formControlName="descripcion"></textarea>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">¿Visible la vacante?*</label>
            <div class="tw-flex tw-items-center tw-gap-5 tw-mt-1">
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="visibleSi" name="visible" [value]="true" formControlName="visible" class="tw-text-blue-600">
                Si
              </label>
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="visibleNo" name="visible" [value]="false" formControlName="visible" class="tw-text-blue-600">
                No
              </label>
            </div>
          </div>

        </div>
      </div>

      <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6 tw-mb-6" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
        <h2 class="tw-text-base tw-font-semibold tw-text-slate-800 tw-mb-5">Requisitos</h2>
        <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4">

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Experiencia*</label>
            <textarea class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" rows="4" formControlName="experiencia"></textarea>
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formVac.controls.experiencia.errors && formVac.controls.experiencia.dirty">
              <div *ngIf="formVac.controls.experiencia.errors.required">La experiencia es requerida.</div>
              <div *ngIf="formVac.controls.experiencia.errors.maxlength">El máximo de caracteres es de 255.</div>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Escolaridad*</label>
            <textarea class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" rows="4" formControlName="escolaridad"></textarea>
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formVac.controls.escolaridad.errors && formVac.controls.escolaridad.dirty">
              <div *ngIf="formVac.controls.escolaridad.errors.required">La escolaridad es requerida.</div>
              <div *ngIf="formVac.controls.escolaridad.errors.maxlength">El máximo de caracteres es de 255.</div>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Conocimientos</label>
            <textarea class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" rows="4" formControlName="conocimiento"></textarea>
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formVac.controls.conocimiento.errors">
              <div *ngIf="formVac.controls.conocimiento.errors.maxlength">El máximo de caracteres es de 255.</div>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Habilidades</label>
            <textarea class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" rows="4" formControlName="habilidad"></textarea>
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formVac.controls.habilidad.errors">
              <div *ngIf="formVac.controls.habilidad.errors.maxlength">El máximo de caracteres es de 255.</div>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Actividades</label>
            <textarea class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" rows="4" formControlName="actividad"></textarea>
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formVac.controls.actividad.errors">
              <div *ngIf="formVac.controls.actividad.errors.maxlength">El máximo de caracteres es de 255.</div>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Rango Edad</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="18 - 40 años" formControlName="edad">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2"
              *ngIf="formVac.controls.edad.errors && (formVac.controls.edad.dirty || formVac.controls.edad.touched)">
              <div *ngIf="formVac.controls.edad.errors.pattern">El formato permitido: (18) ó (18 - 21)</div>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Idioma</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="Inglés" formControlName="idioma">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formVac.controls.idioma.errors">
              <div *ngIf="formVac.controls.idioma.errors.maxlength">El máximo de caracteres es de 20.</div>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Género</label>
            <div class="tw-flex tw-items-center tw-gap-4 tw-mt-1 tw-flex-wrap">
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="masculino" name="genero" value="Masculino" formControlName="genero" class="tw-text-blue-600">
                Masculino
              </label>
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="femenino" name="genero" value="Femenino" formControlName="genero" class="tw-text-blue-600">
                Femenino
              </label>
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="indistinto" name="genero" value="Indistinto" formControlName="genero" class="tw-text-blue-600">
                Indistinto
              </label>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Disponibilidad para mudarse</label>
            <div class="tw-flex tw-items-center tw-gap-5 tw-mt-1">
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="dMudarSi" name="mudar" value="Si" formControlName="mudar" class="tw-text-blue-600">
                Si
              </label>
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="dMudarNo" name="mudar" value="No" formControlName="mudar" class="tw-text-blue-600">
                No
              </label>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Disponibilidad para viajar</label>
            <div class="tw-flex tw-items-center tw-gap-5 tw-mt-1">
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="dViajarSi" name="viajar" value="Si" formControlName="viajar" class="tw-text-blue-600">
                Si
              </label>
              <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer">
                <input type="radio" id="dViajarNo" name="viajar" value="No" formControlName="viajar" class="tw-text-blue-600">
                No
              </label>
            </div>
          </div>

        </div>
      </div>

      <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6 tw-mb-6" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
        <h2 class="tw-text-base tw-font-semibold tw-text-slate-800 tw-mb-5">Oferta</h2>
        <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4">

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Categoría*</label>
            <select class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="categoria">
              <option hidden disabled selected [value]="null">Seleccione la Categoría</option>
              <option *ngFor="let categoria of categorias" [value]="categoria.idCategoria">{{categoria.nombreCategoria}}</option>
            </select>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Tipo de Contratación*</label>
            <select class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="tipoContrato">
              <option hidden disabled selected [value]="null">Seleccione el tipo contrato</option>
              <option [value]="'Tiempo completo'">Tiempo Completo</option>
              <option [value]="'Medio tiempo'">Medio Tiempo</option>
              <option [value]="'Freelance'">Freelance</option>
            </select>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Tiempo de Contratación*</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="Contrato por un año completo." formControlName="especificarContrato">
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Modalidad Empleo*</label>
            <select class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="modalidadEmpleo">
              <option disabled hidden selected [value]="null">Seleccione una modalidad</option>
              <option *ngFor="let modalidad of modalidades" [value]="modalidad.idmodalidadempleo">{{modalidad.nombre}}</option>
            </select>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">País*</label>
            <select class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="pais" (change)="seleccionarPais($event.target.value)">
              <option *ngFor="let pais of paises">{{pais.name}}</option>
            </select>
          </div>

          <div *ngIf="formVac.value.pais == 'México'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Estado</label>
            <select class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="estado" (change)="seleccionarEstado()">
              <option hidden disabled selected [value]="null">Seleccione el Estado</option>
              <option *ngFor="let estado of estados" [value]="estado.id">{{estado.nombre}}</option>
            </select>
          </div>

          <div *ngIf="ciudades && formVac.value.pais == 'México'">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5" *ngIf="formVac.value.estado != 09">Municipio*</label>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5" *ngIf="formVac.value.estado == 09">Alcaldía*</label>
            <select class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="ciudad" (change)="ocultarMensaje()">
              <option hidden disabled selected [value]="null">{{"Seleccione "+ (formVac.value.estado==09?"una Alcaldía.":"un Municipio.")}}</option>
              <option *ngFor="let ciudad of ciudades" [value]="ciudad.claveCiudad">{{ciudad.nombre}}</option>
            </select>
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formVac.value.estado != 09 && seleccionoEstado">
              Debe seleccionar un Municipio.
            </div>
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formVac.value.estado == 09 && seleccionoEstado">
              Debe seleccionar una Alcaldía.
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Dirección</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="Dirección" formControlName="direccion">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2"
              *ngIf="formVac.controls.direccion.errors && (formVac.controls.direccion.dirty || formVac.controls.direccion.touched)">
              <div *ngIf="formVac.controls.direccion.errors.maxlength">El máximo de caracteres es de 255.</div>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Salario Mínimo</label>
            <input type="number" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="16000" formControlName="salarioMin">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2"
              *ngIf="formVac.controls.salarioMin.errors && (formVac.controls.salarioMin.dirty || formVac.controls.salarioMin.touched)">
              <div *ngIf="formVac.controls.salarioMin.errors.maxlength">El máximo de caracteres es de 10.</div>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Salario Máximo</label>
            <input type="number" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="20000" formControlName="salarioMax">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2"
              *ngIf="formVac.controls.salarioMax.errors && (formVac.controls.salarioMax.dirty || formVac.controls.salarioMax.touched)">
              <div *ngIf="formVac.controls.salarioMax.errors.maxlength">El máximo de caracteres es de 10.</div>
            </div>
          </div>

        </div>
      </div>

      <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6 tw-mb-6" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
        <h2 class="tw-text-base tw-font-semibold tw-text-slate-800 tw-mb-5">Contacto</h2>
        <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4">

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Nombre</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="Nombre" formControlName="nombreContacto">
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Apellido Paterno</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="Apellido Paterno" formControlName="aPaterno">
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Apellido Materno</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="Apellido Materno" formControlName="aMaterno">
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Cargo o Función</label>
            <select class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" formControlName="cargo">
              <option hidden disabled selected [value]="null">Seleccione el cargo o función</option>
              <option [value]="'Presidente'">Presidente</option>
              <option [value]="'Director'">Director</option>
              <option [value]="'Gerente'">Gerente</option>
              <option [value]="'Jefe'">Jefe</option>
              <option [value]="'Coordinador'">Coordinador</option>
              <option [value]="'Analista'">Analista</option>
            </select>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Correo</label>
            <input type="email" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="contacto@dominio.com" formControlName="correo">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2"
              *ngIf="formVac.controls.correo.errors && (formVac.controls.correo.dirty || formVac.controls.correo.touched)">
              <div *ngIf="formVac.controls.correo.errors.pattern">El correo no es válido.</div>
            </div>
          </div>

          <div class="tw-min-w-0">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Teléfono</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition"
              formControlName="telefono" minlength="8" maxlength="12"
              name="telefono" id="telefono" appIntlTelInput
              (countrychange)="onCountryChanged($event, false)" [initialCountry]="telefono1" #telefono1>
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2"
              *ngIf="formVac.controls.telefono.errors && (formVac.controls.telefono.dirty || formVac.controls.telefono.touched)">
              <div *ngIf="formVac.controls.telefono.errors.minlength">Debe contener al menos 8 dígitos.</div>
              <div *ngIf="formVac.controls.telefono.errors.maxlength">Debe contener como máximo 12 dígitos.</div>
              <div *ngIf="formVac.controls.telefono.errors.pattern">Sólo se permiten números.</div>
            </div>
          </div>

          <div class="tw-min-w-0">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Teléfono Alterno</label>
            <input type="text" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition"
              formControlName="telefonoAlt" minlength="8" maxlength="12"
              name="telefonoAlt" id="telefonoAlt" appIntlTelInput
              (countrychange)="onCountryChanged($event, true)" [initialCountry]="telefono2" #telefono2>
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2"
              *ngIf="formVac.controls.telefonoAlt.errors && (formVac.controls.telefonoAlt.dirty || formVac.controls.telefonoAlt.touched)">
              <div *ngIf="formVac.controls.telefonoAlt.errors.minlength">Debe contener al menos 8 dígitos.</div>
              <div *ngIf="formVac.controls.telefonoAlt.errors.maxlength">Debe contener como máximo 12 dígitos.</div>
              <div *ngIf="formVac.controls.telefonoAlt.errors.pattern">Sólo se permiten números.</div>
            </div>
          </div>

          <div class="sm:tw-col-span-2">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-amber-50 tw-border tw-border-amber-200 tw-text-sm tw-text-amber-700">
              Atención: Si no específica los datos de contacto, se mostrarán los datos de contacto de la empresa.
            </div>
          </div>

        </div>
      </div>

      <button type="submit"
        class="tw-w-full tw-py-2.5 tw-rounded-xl tw-bg-blue-600 tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer tw-transition"
        style="box-shadow:0 1px 3px rgba(37,99,235,.3)">
        {{(idVacante ? 'Actualizar' : 'Crear')}} Vacante
      </button>

    </form>

  </div>
</div>
